import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import MainInput from "../../../component/atoms/input/mainInput";
import TextArea from "../../../component/atoms/input/textarea";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import FaqApi from "../../../api/faq.api";

function FaqEdit() {
  const navigate = useNavigate();
  let { id } = useParams();

  // mounted
  useEffect(() => {
    getFaqInfo();
  }, []);

  // ----- 정보 가져오기
  const [faqInfo, setFaqInfo] = useState({
    title: "",
    content: "",
    email: "",
    createdAt: "",
  });

  const getFaqInfo = async () => {
    try {
      const response = (await FaqApi.getById(id)).data.data.content;
      setFaqInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 저장
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveFunc = async () => {
    const data = {
      title: faqInfo.title.trim(),
      content: faqInfo.content.trim(),
    };

    try {
      await FaqApi.update(id, data);
      toast(toastMsg.create);
      setSaveModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>수정하기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>제목*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"제목을 입력해주세요"}
                  value={faqInfo.title}
                  onChange={(e) =>
                    setFaqInfo({ ...faqInfo, title: e.target.value })
                  }
                />
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>내용*</DetailFormTitle>
                <TextArea
                  type={"text"}
                  placeholder={"내용을 입력해주세요"}
                  value={faqInfo.content}
                  onChange={(e) =>
                    setFaqInfo({ ...faqInfo, content: e.target.value })
                  }
                  style={{
                    minHeight: "92px",
                  }}
                />
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  if (!faqInfo.title.trim())
                    return toast("제목을 입력해주세요.");
                  if (!faqInfo.content.trim())
                    return toast("내용을 입력해주세요.");

                  setSaveModalOpen(true);
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            saveFunc();
          }}
        />
      ) : null}
    </>
  );
}

export default FaqEdit;
